import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from '@angular/router';

import { map } from 'rxjs/operators';

import { User } from '@entities/user';
import { NavService } from '@shared/services/nav.sevice';

import { AuthenticationService } from '../../authentication.service';

@Injectable({
    providedIn: 'root'
})
export class RoleGuardService implements CanActivate, CanActivateChild {
    private currentUser: User;

    constructor(
        private navService: NavService, 
        private auth: AuthenticationService,
        private router: Router
    ) {
        this.auth.currentUser
            .pipe(
                map((user: User) => {
                    this.currentUser = user;
                })
            )
            .subscribe();
    }

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const expectedRole = (route.data as {expectedRole: any}).expectedRole;

        // Najpierw sprawdź czy użytkownik jest zalogowany
        if (!this.auth.authorizedUser) {
            const currentUrl = window.location.pathname + window.location.search;
            
            if (currentUrl && currentUrl !== '/' && !currentUrl.includes('/login')) {
                sessionStorage.setItem('returnUrl', currentUrl);
            }
            
            this.navService.goToPage('/login');
            return false;
        }

        if (this.auth.checkPrivileges(expectedRole)) {
            return true;
        }
        
        // Zapisz obecny URL przed przekierowaniem do logowania
        const currentUrl = window.location.pathname + window.location.search;
        
        if (currentUrl && currentUrl !== '/' && !currentUrl.includes('/login')) {
            sessionStorage.setItem('returnUrl', currentUrl);
        }
        
        this.navService.goToPage('/login');
        return false;
    }

    public canActivateChild(): boolean {
        return !!this.currentUser;
    }
}
